export enum DocsVerificationFileSizeEnum {
    SUCCESS = 'success',
    BIG = 'big',
    SMALL = 'small',
}
